import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import SupplierWithItemReportModal from "../components/supplierWithItemReportModal";
import Time from "../components/time";
import { useNavigate } from "react-router-dom";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const SupplierWithItemReport = () => {
     useAuthRedirect();
    const [showModal, setShowModal] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const branch = localStorage.getItem("branch");
    const user = localStorage.getItem("username");
    const [sCode, setScode] = useState(null);
    const [sName, setSName] = useState(null);
    const [poNumber, setPoNo] = useState("");
    const [hoDetails, setHoDetails] = useState({});
    const [formData, setFormData] = useState({});
    const navigate = useNavigate();

    const canView  = hasPermission("Supplier - Item", "view");

   
    const handleSelectItem = async (supplier) => {
        try {
            setScode(supplier.supplierMaster_code);
            setSName(supplier.supplierMaster_name);
            const response = await axios.get(
                "https://rfs2.infraconsoft.net.in/api/supplierWithItemReport_list",
                {
                    params: {
                        sCode: supplier.supplierMaster_code,
                    },
                });
            if (response.data.length > 0) {
                setSelectedItems(response.data);
            }
            console.log(response.data);
            
        } catch (error) {
            console.error("Error fetching supplier items:", error);
        }
    };

   
      if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


    return (
        <div id="admin-container">
            <InventoryNav />
            <div className="content-right">
                <section>
                    <h2 className="add-txt">Supplier With Item - Report</h2>
                    <Time />
                </section>

                <div className="form-container">
                    <form className="vehicle-form">
                        <div className="form-row">
                            <div className="form-group">
                                <label>Supplier Code :</label>
                                <input type="text" name="PoNumber" value={sCode} readOnly placeholder="Select Supplier"/>
                            </div>
                            <div className="form-group">
                                <label>Supplier Name :</label>
                                <input type="text" name="PoNumber" value={sName} readOnly />
                            </div>
                        </div>

                        <div className="flex_buttons">
                            <button
                                type="button"
                                className="button button-add"
                                onClick={() => setShowModal(true)}
                            >
                                Select Supplier
                            </button>
                        </div>

                        <div className="content-table">
                            <table>
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Item Code</th>
                                        <th>Item Name</th>
                                        <th>UOM</th>
                                        <th>Price</th>
                                        <th>GST%</th>
                                        <th>PF%</th>
                                        <th>DISC.%</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedItems.length > 0 ? (
                                        selectedItems.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.SupplierWIDetail_itemCode}</td>
                                                    <td>{item.itemMaster_name}</td>
                                                    <td>{item.itemmaster_uom}</td>
                                                    <td>{item.supplierWIdetail_price}</td>
                                                    <td>{item.SupplierWIDetail_CSTtax}</td>
                                                    <td>{item.supplierWIdetail_PfPercentage}</td>
                                                    <td>{item.supplierWIdetail_discountPercentage}</td>
                                                    
                                                   
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="10">No Items</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </form>
                </div>
            </div>

            <SupplierWithItemReportModal
                showModal={showModal}
                closeModal={() => setShowModal(false)}
                branch={branch}
                onSelectItem={handleSelectItem}
            />
        </div>
    );
};

export default SupplierWithItemReport;
